import { observer } from "mobx-react-lite"
import * as React from "react"
import { Appearance, StyleProp, TextStyle, ViewStyle, TouchableOpacity } from "react-native"
import { View } from "native-base"
import { TxKeyPath } from "../../i18n"
import { Button } from "../button/button"
import { Text } from "../text/text"
import { JalaIcon } from "../jala-icon/jala-icon"
import { color } from "../../theme"
import JalaAnalytic from "../../utils/jala-analytic"

const TOOLTIP_BUTTON: ViewStyle = {
  flexDirection: 'row',
  justifyContent: 'flex-end',
  paddingBottom: 10,
  marginTop: 5,
}

const TOOLTIP_TEXT: TextStyle = {
  marginLeft: 10
}

const CLOSE_ICON: ViewStyle = {
  marginLeft: 5,
  width: "10%",
  alignItems: "flex-end"
}

export interface TooltipContentProps {
  /**
   * An optional style override useful for padding & margin.
   */
  style?: StyleProp<ViewStyle>
  title?: TxKeyPath,
  index?: number,
  total?: number,
  colorScheme?: "light" | "dark",
  coachmark?: string,
  onNextPress?: (index) => void,
  onClose?: (value) => void,
  id?: string
}

/**
 * Describe your component here
 */
export const TooltipContent = observer(function TooltipContent(props: TooltipContentProps) {
  const { id, title, index, total, coachmark, onNextPress, onClose, colorScheme = "light" || Appearance.getColorScheme() } = props;

  const last = index === total;
  const nextTitle = last ? "Finished" : "homeScreen.tooltipNext"
  const handlePress = React.useCallback(() => {
    if(last) {
      JalaAnalytic.log('Mobile App: Pond List Coachmark - finish', { id })
      onClose(coachmark)
    } else {
      onNextPress(index + 1)
    }
  }, [coachmark, id, index, last, onClose, onNextPress])
  return (
    <View key={index}>
      <View flexDirection="row" alignItems="flex-start" justifyContent="space-between">
      <View width="90%">
        <Text tx={title} preset="textBase" marginBottom="8px" colorScheme={colorScheme}  />
      </View>
      <TouchableOpacity onPress={() => onClose(coachmark)} style={CLOSE_ICON}>
        <JalaIcon name="close" size={20} color={color.palette.gray800} />
      </TouchableOpacity>
    </View>
    <View style={TOOLTIP_BUTTON}>
      <Button
        testID="jala:id/next-button"
        tx={nextTitle}
        textPreset="title5"
        preset="link"
        colorScheme={colorScheme}
        onPress={handlePress}
        style={TOOLTIP_TEXT}
        textColor={color.primary}
      />
    </View>
    </View>
    )
})
